import { takeLatest, put } from 'redux-saga/effects';
import { STATUS, API, jsonToQueryString } from '@vezeeta/web-utils';
import Cookies from 'js-cookie';

import CoustomUrls from 'configs/urls';
import {
  SERVICES,
  fetchServices,
  fetchServicesSuccess,
  fetchServicesFail,
  fetchServiceDetailsSuccess,
  fetchServiceDetailsFail,
  addEditServiceSuccess,
  addEditServiceFail,
  addEditServiceConflicted,
  fetchParentGroupsSuccess,
  fetchParentGroupsFail,
  fetchServicesCategoriesSuccess,
  fetchServicesCategoriesFail,
  fetchServicesListSuccess,
  fetchServicesListFail,
  loadMoreServicesSuccess,
  fetchProvidersListSuccess,
  fetchProvidersListFail,
  loadMoreProvidersSuccess
} from '../actions/services';

const auth = Cookies.get('AUTH_TOKEN');

function* fetchServicesList(action) {
  if (auth) {
    const headers = [
      {
        key: 'languageId',
        value: '1'
      },
      {
        key: 'Authorization',
        value: `bearer ${auth}`
      }
    ];
    const body = {
      levelId: action.levelId,
      pageIndex: action.pageIndex,
      pageSize: action.pageSize
    };

    const apiWrapper = yield new API();
    const response = yield apiWrapper.get(
      `${CoustomUrls.getAllServices}?${jsonToQueryString(body)}`,
      headers,
      false
    );

    if (STATUS.isSuccess(response.status)) {
      yield put(fetchServicesSuccess(response.data));
    } else if (STATUS.isNotAuthorized(response.status)) {
      Cookies.remove('AUTH_TOKEN');
      window.location.href = '/';
    } else {
      yield put(fetchServicesFail(response));
    }
  } else {
    Cookies.remove('AUTH_TOKEN');
    window.location.href = '/';
  }
}

function* fetchParentGroups(action) {
  if (auth) {
    const headers = [
      {
        key: 'languageId',
        value: '1'
      },
      {
        key: 'Authorization',
        value: `bearer ${auth}`
      }
    ];
    const body = {
      levelId: action.levelId,
      pageIndex: action.pageIndex,
      pageSize: action.pageSize
    };

    const apiWrapper = yield new API();
    const response = yield apiWrapper.get(
      `${CoustomUrls.getAllServices}?${jsonToQueryString(body)}`,
      headers,
      false
    );

    if (STATUS.isSuccess(response.status)) {
      yield put(fetchParentGroupsSuccess(response.data));
    } else if (STATUS.isNotAuthorized(response.status)) {
      Cookies.remove('AUTH_TOKEN');
      window.location.href = '/';
    } else {
      yield put(fetchParentGroupsFail(response));
    }
  } else {
    Cookies.remove('AUTH_TOKEN');
    window.location.href = '/';
  }
}

function* fetchServiceDetails(action) {
  if (auth) {
    const headers = [
      {
        key: 'languageId',
        value: '1'
      },
      {
        key: 'Authorization',
        value: `bearer ${auth}`
      }
    ];

    const body = {
      serviceKey: action.serviceKey
    };

    const apiWrapper = yield new API();
    const response = yield apiWrapper.get(
      `${CoustomUrls.getServiceDetails}?${jsonToQueryString(body)}`,
      headers,
      false
    );
    if (STATUS.isSuccess(response.status)) {
      yield put(fetchServiceDetailsSuccess(response.data));
    } else if (STATUS.isNotAuthorized(response.status)) {
      Cookies.remove('AUTH_TOKEN');
      window.location.href = '/';
    } else {
      yield put(fetchServiceDetailsFail(response));
    }
  } else {
    Cookies.remove('AUTH_TOKEN');
    window.location.href = '/';
  }
}

function* addEditService(action) {
  if (auth) {
    const headers = [
      {
        key: 'Authorization',
        value: `bearer ${auth}`
      }
    ];
    const apiWrapper = yield new API();
    const response = yield apiWrapper.post(CoustomUrls.addService, action.serviceObj, headers);
    if (STATUS.isSuccess(response.status)) {
      yield [
        put(addEditServiceSuccess(response.data)),
        put(fetchServices(action.serviceObj.levelId, 1, 5))
      ];
    } else if (STATUS.isConflict(response.status)) {
      yield [
        put(addEditServiceConflicted(response.response.errorMessage)),
        put(fetchServices(action.serviceObj.levelId, 1, 5))
      ];
    } else if (STATUS.isNotAuthorized(response.status)) {
      Cookies.remove('AUTH_TOKEN');
      window.location.href = '/';
    } else {
      yield put(addEditServiceFail(response));
    }
  } else {
    Cookies.remove('AUTH_TOKEN');
    window.location.href = '/';
  }
}

function* fetchServicesCategories() {
  try {
    const api = new API();
    const res = yield api.get(`${CoustomUrls.getProducts}?productTypeId=5`, [
      {
        key: 'AuthenticationKey',
        value: process.env.REACT_APP_VOUCHERS_AUTHENTICATIONKEY
      }
    ], true);

    if (STATUS.isSuccess(res.status)) {
      yield put(fetchServicesCategoriesSuccess(res.response));
    } else {
      yield put(fetchServicesCategoriesFail());
    }
  } catch (err) {
    yield put(fetchServicesCategoriesFail());
  }
}

function* fetchServicesSaga(action) {
  try {
    const api = new API();
    const pageSize = 50;
    const { searchTerm, page, categoryKey } = action;
    const queryParams = {
      query: searchTerm || '',
      categoryKey: categoryKey.toLowerCase() || 'inclinic',
      pagesize: pageSize,
      PageNum: page || 1
    };

    const apiUrl = `${CoustomUrls.services.medicalServices}?${jsonToQueryString(queryParams)}`;
    
    const res = yield api.get(apiUrl, undefined, true);

    if (STATUS.isSuccess(res.status)) {
      const services = res.response.data || [];
      const hasMore = services.length === pageSize; // Only has more if we got exactly pageSize items
      
      // Format services for dropdown - match Vezeeta Select component format
      const formattedServices = services.map(service => ({
        value: service.serviceKey,
        fieldValue: service.serviceNameEn || service.serviceNameAr,
        children: service.serviceNameEn || service.serviceNameAr,
        searchable: [service.serviceNameEn || service.serviceNameAr],
        serviceNameAr: service.serviceNameAr,
        serviceNameEn: service.serviceNameEn,
        isPopular: service.isPopular
      }));
      
      // Always add an empty item at the end for clearing selection
      const servicesWithEmpty = [
        ...formattedServices,
        {
          value: '',
          fieldValue: '',
          children: '',
          searchable: [''],
          isClearOption: true
        }
      ];
      
      // Determine if this is a load more action or initial load
      const isLoadMore = action.type === SERVICES.FETCH_SERVICES_LIST.LOAD_MORE;
      
      if (isLoadMore) {
        yield put(loadMoreServicesSuccess(servicesWithEmpty, hasMore));
      } else {
        yield put(fetchServicesListSuccess(servicesWithEmpty, hasMore));
      }
    } else {
      // Handle error based on action type
      const isLoadMore = action.type === SERVICES.FETCH_SERVICES_LIST.LOAD_MORE;
      
      if (isLoadMore) {
        yield put(loadMoreServicesSuccess([], false)); // Don't fail, just return empty
      } else {
        yield put(fetchServicesListFail());
      }
    }
  } catch (err) {
    // Handle error based on action type
    const isLoadMore = action.type === SERVICES.FETCH_SERVICES_LIST.LOAD_MORE;
    
    if (isLoadMore) {
      yield put(loadMoreServicesSuccess([], false)); // Don't fail, just return empty
    } else {
      yield put(fetchServicesListFail());
    }
  }
}

// Unified configuration for all API endpoints
const API_CONFIGS = {
  // Doctors API (InClinic, Surgical)
  DOCTORS: {
    baseUrl: CoustomUrls.services.doctorsSearch,
    queryParams: 'BookingTypes=physical,telehealth&includeExclusive=true',
    pageSize: 10,
    responsePath: 'Result',
    searchParam: 'doctorname',
    pageParam: 'page',
    sizeParam: null,
    needsHeaders: true
  },
  // Branches API (Labs, Scans)
  BRANCHES: {
    baseUrl: CoustomUrls.services.branches,
    queryParams: 'statusid=5&IncludeNoShowPricesEntities=true',
    pageSize: 50,
    responsePath: 'Data.Results',
    searchParam: 'searchterm',
    pageParam: 'PageNum',
    sizeParam: 'PageSize',
    needsHeaders: false
  }
};

// Category to API type mapping
const CATEGORY_API_MAPPING = {
  'InClinic': 'DOCTORS',
  'Surgical': 'DOCTORS',
  'Labs': 'BRANCHES',
  'Scans': 'BRANCHES'
};

// Helper function to determine providers API type based on category
function getProvidersApiType(categoryKey) {
  return CATEGORY_API_MAPPING[categoryKey] || 'SERVICES';
}

// Helper function to build providers API URL with query parameters
function buildProvidersApiUrl(config, searchTerm, page, categoryKey) {
  const { baseUrl, queryParams, searchParam, pageParam, sizeParam, pageSize } = config;
  const encodedSearchTerm = encodeURIComponent(searchTerm || '');
  
  // Build query params with dynamic BookingTypeId based on category
  let finalQueryParams = queryParams;
  if (categoryKey === 'Labs') {
    finalQueryParams += '&BookingTypeId=5';
  } else if (categoryKey === 'Scans') {
    finalQueryParams += '&BookingTypeId=6';
  }
  
  let url = `${baseUrl}?${finalQueryParams}`;
  
  // Add search parameter
  if (searchParam) {
    url += `&${searchParam}=${encodedSearchTerm}`;
  }
  
  // Add page parameter
  if (pageParam) {
    url += `&${pageParam}=${page}`;
  }
  
  // Add size parameter if needed
  if (sizeParam) {
    url += `&${sizeParam}=${pageSize}`;
  }
  
  return url;
}

// Helper function to build headers for providers API request
function buildProvidersHeaders(apiType, countryData) {
  if (apiType === 'DOCTORS' && countryData) {
    const { CountryId, ISOCode } = countryData;
    return [
      { key: 'CountryId', value: CountryId },
      { key: 'Accept-Language', value: `en-${ISOCode}` }
    ];
  }
  return undefined;
}

// Helper function to get providers API configuration
function getProvidersApiConfig(categoryKey, searchTerm, page, countryData) {
  const apiType = getProvidersApiType(categoryKey);
  const config = API_CONFIGS[apiType];
  
  return {
    url: buildProvidersApiUrl(config, searchTerm, page, categoryKey),
    headers: buildProvidersHeaders(apiType, countryData),
    pageSize: config.pageSize,
    responsePath: config.responsePath,
    apiType
  };
}

// Helper function to safely extract nested object properties for providers
function getProvidersNestedValue(obj, path) {
  return path.split('.').reduce((current, key) => current?.[key], obj) || [];
}













// Helper function to format provider for dropdown
function formatProviderForDropdown(provider, apiType) {
  let displayName;
  let key;
  
  if (apiType === 'BRANCHES') {
    displayName = provider.NameEnglish || provider.NameArabic || '';
    key = provider.ParentModel.EntityKey;
  } else if (apiType === 'DOCTORS') {
    displayName = provider.TopLevelEntityName || 
                  provider.DoctorName || 
                  provider.Name || 
                  provider.EntityName || '';
    key = provider.TopLevelEntityKey;
  } else {
    // Services fallback
    displayName = provider.serviceNameEn || provider.serviceNameAr || '';
    key = provider.serviceKey;
  }
  
  return {
    value: key,
    fieldValue: displayName,
    children: displayName,
    searchable: [displayName]
  };
}

// Helper function to create clear option for providers
function createProvidersClearOption() {
  return {
    value: '',
    fieldValue: '',
    children: '',
    searchable: [''],
    isClearOption: true
  };
}

// Helper function to process providers data based on API type
function processProvidersData(rawData, apiType, categoryKey) {
    // Providers (DOCTORS, BRANCHES)
    const formattedProviders = rawData
      .filter(item => item && (item.BranchKey || item.TopLevelEntityKey || item.serviceKey))
      .map(provider => formatProviderForDropdown(provider, apiType));
    
    return [...formattedProviders, createProvidersClearOption()];
}

// Helper function to validate providers action parameters
function validateProvidersActionParameters(action) {
  const { categoryKey } = action;
  
  if (!categoryKey) {
    throw new Error('Category key is required');
  }
  
  return true;
}

// Helper function to validate country data for providers
function validateProvidersCountryData(countryData) {
  if (!countryData) {
    throw new Error('Country data is required for providers');
  }
  
  if (!countryData.ISOCode || !countryData.CountryId) {
    throw new Error('Invalid country data: missing ISOCode or CountryId');
  }
  
  return countryData;
}

// Unified saga for both services and providers
function* fetchProvidersSaga(action) {
  try {
    // Validate input parameters
    validateProvidersActionParameters(action);
    
    const { categoryKey, searchTerm, page, countryData } = action;
    
    // Validate country data (only needed for providers)
    const validatedCountryData = validateProvidersCountryData(countryData);
    
    // Get API configuration
    const apiConfig = getProvidersApiConfig(categoryKey, searchTerm || '', page || 1, validatedCountryData);
    
    // Make API call
    const api = new API();
    const response = yield api.get(apiConfig.url, apiConfig.headers, true);
    
    if (!STATUS.isSuccess(response.status)) {
      throw new Error(`API request failed with status: ${response.status}`);
    }
    
    // Extract data from response
    const rawData = getProvidersNestedValue(response.response, apiConfig.responsePath);
    const hasMore = rawData.length === apiConfig.pageSize;
    const processedData = processProvidersData(rawData, apiConfig.apiType, categoryKey);
    
    // Determine action type and dispatch appropriate success action
    const isLoadMore = action.type.includes('LOAD_MORE');
    const isServices = categoryKey === 'services';
    
    let successAction;
    if (isServices) {
      successAction = isLoadMore ? 
        loadMoreServicesSuccess(processedData, hasMore) : 
        fetchServicesListSuccess(processedData, hasMore);
    } else {
      successAction = isLoadMore ? 
        loadMoreProvidersSuccess(processedData, hasMore) : 
        fetchProvidersListSuccess(processedData, hasMore);
    }
    
    yield put(successAction);
    
  } catch (error) {
    // Log error for debugging (in development)
    if (process.env.NODE_ENV === 'development') {
      console.error('fetchProvidersSaga error:', error.message);
    }
    
    // Dispatch appropriate fail action based on category
    const { categoryKey } = action;
    const isServices = categoryKey === 'services';
    
    if (isServices) {
      yield put(fetchServicesListFail());
    } else {
      yield put(fetchProvidersListFail());
    }
  }
}

function* servicesSaga() {
  yield takeLatest(SERVICES.FETCH.LOAD, fetchServicesList);
  yield takeLatest(SERVICES.FETCH_PARENT_GROUP.LOAD, fetchParentGroups);
  yield takeLatest(SERVICES.FETCH_DETAILS.LOAD, fetchServiceDetails);
  yield takeLatest(SERVICES.ADD_EDIT.LOAD, addEditService);
  yield takeLatest(SERVICES.FETCH_CATEGORIES.LOAD, fetchServicesCategories);
  
  // Services saga (unified)
  yield takeLatest(SERVICES.FETCH_SERVICES_LIST.LOAD, fetchServicesSaga);
  yield takeLatest(SERVICES.FETCH_SERVICES_LIST.LOAD_MORE, fetchServicesSaga);
  
  // Providers sagas
  yield takeLatest(SERVICES.FETCH_PROVIDERS_LIST.LOAD, fetchProvidersSaga);
  yield takeLatest(SERVICES.FETCH_PROVIDERS_LIST.LOAD_MORE, fetchProvidersSaga);
}

export default servicesSaga;
